import moment from 'moment';

import schemaTitular from '../../AdicionarBeneficiario/Titular/schema';
import schemaDependente from '../../AdicionarBeneficiario/Dependente/schema';

import { cloneObject, addMaskCpf, addMaskSus } from '../../../../utils';

function inclusaoDependente(form) {
    const { busca: titular, form: dependente } = form;

    const dadosTitular = cloneObject(schemaTitular);

    dadosTitular.cardNumber.value = titular.numeroCarteira;
    dadosTitular.company.value = titular.codigoEmpresa;
    dadosTitular.company.lookup = titular.nomeEmpresa;
    dadosTitular.contractName.value = titular.nomeContrato;
    dadosTitular.cpf.value = addMaskCpf(titular.cpf);
    dadosTitular.cpf.unmaskedValue = titular.cpf;
    dadosTitular.fullName.value = titular.nome;
    dadosTitular.healthPlan.value = titular.codigoPlano;
    dadosTitular.healthPlan.lookup = titular.nomePlano;
    dadosTitular.dateStartPlan.value = moment(titular.dataInclusao, 'MM/DD/YYYY HH:mm:ss').toISOString();
    dadosTitular.functionalEnrollment.value = dependente.numeroMatriculaNaEmpresa;

    const dadosDependente = cloneObject(schemaDependente);

    dadosDependente.birth.value = dependente.dataNascimento && moment(dependente.dataNascimento).toISOString();
    dadosDependente.civilState.value = dependente.estadoCivil;
    dadosDependente.civilState.lookup = dependente.nomeEstadoCivil;
    dadosDependente.cpf.value = addMaskCpf(dependente.numeroCPF);
    dadosDependente.cpf.unmaskedValue = dependente.numeroCPF;
    dadosDependente.dateStartPlan.value = dependente.dataInclusao && moment(dependente.dataInclusao).toISOString();
    dadosDependente.dn.value = dependente.numeroDeclaracaoNascidoVivo;
    dadosDependente.enrollmentSequence.value = dependente.numeroSequencialMatricula;
    dadosDependente.fullName.value = dependente.nomeAssociado;
    dadosDependente.gender.value = dependente.sexo;
    dadosDependente.gender.lookup = dependente.sexo && (dependente.sexo === 'M' ? 'Masculino' : 'Feminino');
    dadosDependente.healthPlan.value = dependente.codigoPlano;
    dadosDependente.healthPlan.lookup = dependente.nomePlano;
    dadosDependente.kinshipDegree.value = dependente.codigoDependencia;
    dadosDependente.kinshipDegree.lookup = dependente.nomeDependencia;
    dadosDependente.motherName.value = dependente.nomeMae;
    dadosDependente.nationality.value = dependente.nacionalidade;
    dadosDependente.nationality.lookup =
        dependente.nacionalidade && (dependente.nacionalidade === 'B' ? 'Brasileira' : 'Estrangeira');
    dadosDependente.pis.value = dependente.numeroPIS;
    dadosDependente.socialName.value = dependente.nomeSocial;
    dadosDependente.sus.value = addMaskSus(dependente.numeroUnicoSaude);
    dadosDependente.sus.unmaskedValue = dependente.numeroUnicoSaude;
    dadosDependente.weddingDate.value = dependente.dataCasamento && moment(dependente.dataCasamento).toISOString();
    dadosDependente.weight.value = dependente.peso;
    dadosDependente.height.value = dependente.altura;

    return {
        dadosTitular,
        dadosDependente: [dadosDependente],
    };
}

export { inclusaoDependente };
